import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationServiceProvider } from '../../auth_profile/services/authorization-service.provider';
import { UserRole } from '../../auth_profile/services/api/authorization.api';
import { LogsService } from '../../utils/services/logs.service';

@Component({
    selector: 'app-book-list-entry-point',
    templateUrl: './book-list-entry-point.component.html',
    styleUrls: ['./book-list-entry-point.component.scss'],
    standalone: false
})
export class BookListEntryPointComponent implements OnInit {

  constructor(private router: Router,
              private authService: AuthorizationServiceProvider,
              private logger: LogsService) {
  }

  ngOnInit(): void {
    this.authService.getMobile().subscribe(
      mobileApi => mobileApi.getUserRole().subscribe(
        userRole => {
          this.logger.log(`[BookListEntryPoint] mobile userRole=${userRole}`);
          if (userRole === UserRole.Student) this.router.navigate(['student/ebooks'])
          else if (userRole === UserRole.Teacher) this.router.navigate(['teacher/ebooks'])
          else if (userRole === UserRole.Unaffiliated) this.router.navigate(['unaffiliated/ebooks'])
          else {
            this.logger.log(`[BookListEntryPoint] unknown role=${userRole} -> /forbidden`);
            this.router.navigate(['forbidden'])
          }
        }
      )
    )
  }

}
